import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'phoenix-snackbar',
  template: `
    <div
      class="flex justify-between items-center"
      [attr.aria-label]="'phoenix-snackbar'"
    >
      <div
        class="text-sm overflow-hidden py-2.5 threat-entity-form__break-snackbar"
        [innerHTML]="data.html"
      ></div>
      <button
        mat-icon-button
        class="material-icons-outlined"
        (click)="snackBar.dismiss()"
        [attr.aria-label]="'snackbar-dismiss-button'"
      >
        cancel
      </button>
    </div>
  `,
  styles: [
    `
      .threat-entity-form {
        &__break-snackbar {
          white-space: pre-wrap;
        }
      }
    `,
  ],
  standalone: false,
})
export class SnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBar: MatSnackBar
  ) {}
}
